import type { DownloadLanguageStorage } from './interface';

export const STORE_NAME = 'DownloadTour';

export const initialState: DownloadLanguageStorage = {
    userSession: '',
    languageId: -1,
    tourId: -1,
    progressBar: -1,
    progressVisible: false,
};
